import { ApplicationSettingsProps, NotaKeycloakTokenParsed } from '@/lib/types';
import { TooltipItem } from '@/lib/types/tooltip';
import { UserRoles } from '@/lib/types/enums';
import { atom } from 'jotai';
import Keycloak from 'keycloak-js';

export const payableInvoiceCountAtom = atom<number>(0);

export const applicationSettingsAtom = atom<ApplicationSettingsProps>({
  maxFileSize: 4,
  maxFileCount: 20,
  pageSize: 10,
});

const keycloak = new Keycloak({
  clientId: (globalThis as any).AUTH_CLIENT_ID,
  realm: (globalThis as any).AUTH_REALM,
  url: (globalThis as any).AUTH_URL + '/auth',
});

export const keycloakInstanceAtom = atom(keycloak);
const emptyParsedToken = {} as NotaKeycloakTokenParsed;
const parsedTokenAtom = atom<NotaKeycloakTokenParsed>(emptyParsedToken);

export const isAuthenticatedAtom = atom(false);

export const tooltipsAtom = atom<TooltipItem[]>([]);

export const appNameAtom = atom('Mkbnota');

export const userRolesAtom = atom<{
  isAccountManager: boolean;
  roles: string[];
}>((get) => {
  const roles = get(parsedTokenAtom).roles ?? [];

  const rolesObject = {
    isAccountManager: roles?.includes(UserRoles.ACCOUNT_MANAGER) ?? false,
    roles,
  };

  return rolesObject;
});

export const userTokenParsed = atom<NotaKeycloakTokenParsed>((get) => {
  return get(parsedTokenAtom);
});

export const hasAccessAtom = atom((get) => {
  const parsedToken = get(parsedTokenAtom);
  const userRoles = parsedToken.roles ?? [];

  const isAdmin = userRoles.includes(UserRoles.APP_ADMIN);
  const isAccountManager =
    userRoles.includes(UserRoles.ACCOUNT_MANAGER) && !isAdmin;
  const isCustomer = !isAdmin && !isAccountManager;
  const canImpersonate = isAdmin || isAccountManager;

  return {
    isSupport: parsedToken.preferred_username.endsWith('@vaa.com') && isAdmin, // possible future improvement: make this a seperate role
    roles: userRoles,
    isAdmin,
    isAccountManager,
    isCustomer,
    canImpersonate,
  };
});

export const refreshParsedTokenAtom = atom(null, (get, set) => {
  set(
    parsedTokenAtom,
    (get(keycloakInstanceAtom).idTokenParsed as NotaKeycloakTokenParsed) ??
      emptyParsedToken,
  );
});

export const clearParsedTokenAtom = atom(null, (_get, set) => {
  set(parsedTokenAtom, emptyParsedToken);
});
